import React, { PropsWithChildren } from "react";

import { QueryAwait } from "@steto-care/steto-query";

import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseSuspenseHiddenProps = PropsWithChildren<{}>;

export type SuspenseHiddenProps = AtomProps<BaseSuspenseHiddenProps>;

export const SuspenseHidden: React.FC<SuspenseHiddenProps> = ({ id, className, children, ...props }) => {
  return (
    <QueryAwait pendingFallback={() => null} errorFallback={() => null} {...props}>
      {children}
    </QueryAwait>
  );
};
